export const isBusinessRoute = (asPath: string) => asPath.startsWith('/business');
